<template>
  <!-- MODULE USER SETTINGS -->
  <v-flex
    class="pa-1"
    xs12
    sm6
    lg4
    xl3
    v-if="
      $store.state.storeClient.client.modules.moduleUserSettings.active &&
      $store.state.storeClient.client.modules.moduleUserSettings.show
    "
  >
    <v-card
      :class="
        getTheme() == 'dark' ? 'outlined elevation-0' : 'flat elevation-0'
      "
      :style="
        getTheme() == 'dark'
          ? 'border: 1px solid darkgray'
          : 'border-bottom: 1px solid lightgray'
      "
    >
      <v-img
        class="align-start hover-item"
        height="140px"
        :src="
          $store.state.storeClient.client.modules.moduleUserSettings.menuImage
            .length > 0
            ? $store.state.storeClient.client.modules.moduleUserSettings
                .menuImage
            : usersSettingsImage
        "
        @click="$router.push({ name: 'userSettings' })"
      >
        <v-card-title class="overline text-no-wrap">
          <div>
            <span
              v-if="
                $store.state.storeClient.client.modules.moduleUserSettings
                  .subtitle.length > 0
              "
              :style="
                $store.state.storeClient.client.modules.moduleUserSettings
                  .whiteText
                  ? 'color: whitesmoke'
                  : 'color: #505050'
              "
            >
              {{
                $store.state.storeClient.client.modules.moduleUserSettings
                  .subtitle
              }}
            </span>
            <span
              v-else
              :style="
                $store.state.storeClient.client.modules.moduleUserSettings
                  .whiteText
                  ? 'color: whitesmoke'
                  : 'color: #505050'
              "
              >{{ $t("dashboardCardUserSettingsTitle") }}</span
            >
          </div>
        </v-card-title>
        <v-card-subtitle class="text-no-wrap body-1 font-weight-black pb-3">
          <span
            v-if="
              $store.state.storeClient.client.modules.moduleUserSettings.title
                .length > 0
            "
            :style="
              $store.state.storeClient.client.modules.moduleUserSettings
                .whiteText
                ? 'color: whitesmoke'
                : 'color: #505050'
            "
          >
            {{
              $store.state.storeClient.client.modules.moduleUserSettings.title
            }}
          </span>
          <span
            v-else
            :style="
              $store.state.storeClient.client.modules.moduleUserSettings
                .whiteText
                ? 'color: whitesmoke'
                : 'color: #505050'
            "
          >
            {{ $t("msgWelcomeText") }}
            <span v-if="$store.state.storeAuth.userProfile.fullName">
              {{ $store.state.storeAuth.userProfile.fullName }}
            </span>
            <span v-else>
              {{ $t("dashboardCardUserSettingsSubTitleUnknownUser") }}
            </span>
          </span>
        </v-card-subtitle>
        <v-card-text
          v-if="$store.state.storeAuth.userProfile.country == ''"
          class="d-flex subtitle-2 my-0 py-0 align-center"
          :style="
            $store.state.storeClient.client.modules.moduleUserSettings.whiteText
              ? 'color: whitesmoke'
              : 'color: #505050'
          "
        >
          <v-icon color="warning" class="mr-1">mdi-alert</v-icon>
          {{ $t("dashboardCardUserSettingsUpdateProfileWarning") }}
        </v-card-text>
        <v-card-text>
          <div>
            {{ $t("appVersionTitle") }}: {{ $store.getters.appVersion }} /
            {{ $store.state.os }} / {{ $store.state.browser }} /
            {{ $store.state.memory }}Gb
          </div>
          <div>
            {{ $t("appMaxCanvasSize") }}:
            {{ $store.state.maxCanvasSize.width }} x
            {{ $store.state.maxCanvasSize.height }} px
          </div>
        </v-card-text>
      </v-img>
      <v-card-actions
        :style="
          getTheme() == 'dark'
            ? 'background-color: #505050'
            : 'background-color: white'
        "
      >
        <v-spacer></v-spacer>
        <home-menu-card-action-btn
          path="/userSettings"
          icon="mdi-settings"
          :title="$t('dashboardCardUserSettingsUpdateButtonTitle')"
        ></home-menu-card-action-btn>
        <v-spacer></v-spacer>
      </v-card-actions>
      <home-menu-edit-card-btn
        path="/settingsUserSettingsBasic"
      ></home-menu-edit-card-btn>
    </v-card>
  </v-flex>
</template>
 
<script>
import HomeMenuEditCardBtn from "@/components/HomeMenuEditCardBtn";
import HomeMenuCardActionBtn from "@/components/HomeMenuCardActionBtn";

export default {
  name: "homeMenuUserSettings",
  components: {
    HomeMenuEditCardBtn,
    HomeMenuCardActionBtn,
  },
  data() {
    return {
      usersSettingsImage: require("@/assets/usersSettings.jpg"),
    };
  },
};
</script>
